const SCROLLABLE_OVERFLOW = /auto|scroll|overlay/;

/** Scrollable ancestors of `node`, plus `window` for page-level scroll. */
export const getScrollableParents = (node: HTMLElement | null): EventTarget[] => {
  const scrollParents: EventTarget[] = [];
  let current = node?.parentElement ?? null;

  while (current) {
    const style = window.getComputedStyle(current);
    const overflowValues = [style.overflow, style.overflowX, style.overflowY].join(
      " "
    );

    if (SCROLLABLE_OVERFLOW.test(overflowValues)) {
      scrollParents.push(current);
    }

    current = current.parentElement;
  }

  scrollParents.push(window);
  return scrollParents;
};

/** Close an open dropdown when any relevant scroll container or viewport resizes. */
export const subscribeCloseOnScroll = (
  node: HTMLElement | null,
  onClose: () => void
): (() => void) => {
  const closeOnScroll = () => onClose();

  const scrollParents = getScrollableParents(node);

  scrollParents.forEach((target) => {
    target.addEventListener("scroll", closeOnScroll, { passive: true });
  });
  window.addEventListener("resize", closeOnScroll);

  return () => {
    scrollParents.forEach((target) => {
      target.removeEventListener("scroll", closeOnScroll);
    });
    window.removeEventListener("resize", closeOnScroll);
  };
};
